/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'slots-phone-private': {
    width: 100,
    height: 100,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M504.8 419.1l-106-106c-6.9-6.9-18.1-6.9-24.9 0l-35 35c-10 10-25.4 14.9-38.4 9.3-74.6-32.1-115-72.3-145.9-145.7-5.4-12.9-.4-28.2 9.5-38.1l35.2-35.2c6.9-6.9 6.9-18.1 0-24.9l-106-106c-6.9-6.9-18.1-6.9-25 0L27.9 47.7C3.7 71.9-4.2 108 7.1 140.3c62.2 178 183.8 299.4 364.6 364.2 32.4 11.6 68.9 3.8 93.3-20.5l39.9-39.9c6.8-7 6.8-18.1-.1-25z"/><path pid="1" d="M316.7 230.6h182.7c5.6 0 10.2-4.5 10.2-10.2V113.9c0-5.6-4.5-10.2-10.2-10.2h-15.7V78.1c0-41.8-34-75.9-75.9-75.9-41.8 0-75.9 34-75.9 75.9v25.6h-15.2c-5.6 0-10.2 4.5-10.2 10.2v106.6c0 5.6 4.6 10.1 10.2 10.1zm66-152.5c0-13.9 11.3-25.1 25.1-25.1 13.9 0 25.1 11.3 25.1 25.1v25.6h-50.3V78.1z"/>'
  }
})
